export function chunkArray(myArray: any[], chunkSize: number) {
  const results = [];

  while (myArray.length) {
    results.push(myArray.splice(0, chunkSize));
  }

  return results;
}
